<script>
    import { Route, Router } from "svelte-navigator";
    import ConfigurePlayer from "./ConfigurePlayer.svelte";
    import Locations from "./Locations.svelte";
    import Networks from "./Networks.svelte";
    import Players from "./Players.svelte";
    import RegisterPlayer from "./RegisterPlayer.svelte";
</script>

<Router>
    <main>
        <Route path="/*" let:params>
            <Networks />
        </Route>
        <Route path=":id" let:params>
            <Locations networkId={params.id} />
        </Route>
        <Route path=":networkId/:locationId" let:params>
            <Players
                networkId={params.networkId}
                locationId={params.locationId}
            />
        </Route>
        <Route path=":networkId/:locationId/new" let:params>
            <RegisterPlayer
                networkId={params.networkId}
                locationId={params.locationId}
            />
        </Route>
        <Route
            path=":networkId/:locationId/new/:playerId/configure/"
            let:params
        >
            <ConfigurePlayer
                networkId={params.networkId}
                locationId={params.locationId}
                playerId={params.playerId}
            />
        </Route>
    </main>
</Router>
